import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useDispatch, useSelector } from "react-redux";
import { deleteSurveyData, getSurveys } from "../../../actions/adminSurveyActions";
import { exportSurveysToCsv } from "../../../utils/exportSurveysCsv";
import Loader from "../../Loader";

const ITEMS_PER_PAGE = 10;

const ListSurveys = () => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getSurveys());
  }, [dispatch]);

  const { surveys = [], user_loading } = useSelector((state) => state.surveyList || {});

  const allItems = (surveys || []).slice().sort((a, b) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return dateB - dateA;
  });

  const totalPages = Math.ceil(allItems.length / ITEMS_PER_PAGE);
  const paginatedItems = allItems.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);

  const handleDeleteSurvey = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteSurveyData(id));
            alert.success("Survey deleted successfully");
            dispatch(getSurveys());
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Manage
              <small> User Surveys</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <Link to="/admin">
                  <i className="fa fa-dashboard"></i> Dashboard
                </Link>
              </li>
              <li className="active">User Surveys</li>
            </ol>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box">
                  <div className="box-header">
                    <h3 className="box-title">User Research Surveys</h3>
                    <div className="pull-right" style={{ lineHeight: "30px" }}>
                      {allItems.length > 0 && (
                        <span style={{ color: "#888", marginRight: "10px" }}>
                          Showing {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
                          {Math.min(currentPage * ITEMS_PER_PAGE, allItems.length)} of {allItems.length}
                        </span>
                      )}
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        disabled={!allItems.length}
                        onClick={() => exportSurveysToCsv(allItems)}
                      >
                        <i className="fa fa-download"></i> Export CSV
                      </button>
                      <Link to="/admin/email-campaign" className="btn btn-warning btn-sm" style={{ marginLeft: "8px" }}>
                        <i className="fa fa-envelope"></i> Email survey invite
                      </Link>
                    </div>
                  </div>
                  <div className="box-body table-responsive no-padding">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Date</th>
                          <th>Student</th>
                          <th>Email</th>
                          <th>Exam(s)</th>
                          <th>Age</th>
                          <th>Satisfaction</th>
                          <th>Recommend</th>
                          <th>Usage</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedItems.length ? (
                          paginatedItems.map((item, index) => (
                            <tr key={item._id}>
                              <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                              <td style={{ whiteSpace: "nowrap" }}>
                                {item.createdAt
                                  ? new Date(item.createdAt).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })
                                  : "-"}
                              </td>
                              <td>{item.userName || "Anonymous"}</td>
                              <td>{item.userEmail || "—"}</td>
                              <td>{(item.examTypes || []).join(", ") || "-"}</td>
                              <td>{item.ageRange || "-"}</td>
                              <td>{item.satisfaction || "-"}</td>
                              <td>{item.recommendScore ?? "-"}</td>
                              <td>{item.usageFrequency || "-"}</td>
                              <td>
                                <Link to={`/admin/surveys/detail/${item._id}`} className="btn btn-success btn-sm" title="View">
                                  <i className="fas fa-eye"></i>
                                </Link>
                                &nbsp;
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  title="Delete"
                                  onClick={() => handleDeleteSurvey(item._id)}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10">No records found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </Fragment>
  );
};

export default ListSurveys;
